export enum StoreTypeEnum {
  WITH_GAS_STATION = 'WITH_GAS_STATION',
  WITHOUT_GAS_STATION = 'WITHOUT_GAS_STATION',
  ONLY_GAS_STATION = 'ONLY_GAS_STATION',
}
